import React from "react";
import { Link } from "react-router-dom";
import { parseRichText } from "../../seo/richText.js";

/**
 * Renders body text that may contain inline links written as [label](/path).
 *
 * Drop-in replacement for `{someText}` anywhere article copy is rendered. See
 * src/seo/richText.js for the syntax and why links live in the text rather than
 * in a block type of their own.
 *
 * Internal paths use react-router's <Link> so they navigate client-side and
 * keep the SPA intact; a plain <a href="/blog/..."> would force a full reload
 * and throw away the app state on every contextual link in an article.
 */
const RichText = ({ text }) => (
  <>
    {parseRichText(text).map((part, i) =>
      part.type === "link" ? (
        part.href.startsWith("/") ? (
          <Link
            key={i}
            to={part.href}
            className="text-[var(--accent)] underline decoration-[var(--accent)]/35 underline-offset-2 hover:decoration-[var(--accent)]"
          >
            {part.text}
          </Link>
        ) : (
          <a
            key={i}
            href={part.href}
            target="_blank"
            // noopener is the security half (the opened page can't touch
            // window.opener); noreferrer keeps us from leaking the referrer to
            // third parties. External links are also not endorsements, hence
            // nofollow is left off deliberately for IRS.gov — citing the
            // authoritative source is exactly what we want crawlers to see.
            rel="noopener noreferrer"
            className="text-[var(--accent)] underline decoration-[var(--accent)]/35 underline-offset-2 hover:decoration-[var(--accent)]"
          >
            {part.text}
          </a>
        )
      ) : (
        <React.Fragment key={i}>{part.text}</React.Fragment>
      )
    )}
  </>
);

export default RichText;
